import { useState, useEffect } from 'react';

export const useVersion = () => {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    fetch('/version.json')
      .then((r) => (r.ok ? r.json() : null))
      // versionLabel = "AA.MM.DD_HH.mm" (lo que se pinta). Fallback a version
      // (solo fecha) por si el version.json aun no se regenero tras el deploy
      // que agrego versionLabel.
      .then((data) => {
        const label = data?.versionLabel || data?.version;
        if (label) setVersion(label);
      })
      .catch(() => {});
  }, []);

  return version;
};
